const formatUserLocation = user => {
  const { city, regionName, countryName } = user.location;
  return [city, regionName, countryName]
    .filter(item => item != null)
    .slice(0, 2)
    .join(', ');
};

const usersContentPrivacyPolicy = (context, contentType) => {
  if (!context.currentUser) return;

  return context.currentUser.privacyPolicy?.content[contentType]?.visibility;
};

export { formatUserLocation, usersContentPrivacyPolicy };
